import React, {FC} from "react"
import {Custom} from "../Custom"
import {HttpService} from "../../service/HttpService"
import {AuthService} from "../../service/AuthService";
import {Faq} from "./Faq";

export const FaqPage: FC = () => {
    const customProject = HttpService?.customProject

    return (
        <>
            {customProject?.customFrontend &&
            customProject?.frontendComponents?.some(component => (component?.pathUrl === "/public/faq-custom" && !AuthService.authorized) || component?.pathUrl === "/faq-custom")
                ? (
                    <Custom
                        customFrontendUrl={customProject?.customFrontendUrl}
                        type={customProject?.frontendComponents?.find(comp =>
                            ((comp?.pathUrl === "/public/faq-custom" && !AuthService.authorized) || comp?.pathUrl === "/faq-custom")
                        )?.component}
                    />
                )
                : <Faq />
            }
        </>
    )
}
